var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"api-item-container"},[_vm._v(" 首页内容 ")])}
var staticRenderFns = []

export { render, staticRenderFns }